export default "__VITE_ASSET__701d65ad__"